/**
 * AntD 5 predates React 19 and still calls `ReactDOM.render` for its static methods
 * (`message.success`, `Modal.confirm`, `notification.*`). This patch — Ant Design's own
 * — swaps those for the React 19 API. It MUST be the first import: anything that pulls
 * in antd before it runs gets the unpatched version and warns at runtime.
 */
import '@ant-design/v5-patch-for-react-19';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles/index.css';

const container = document.getElementById('root');
if (!container) throw new Error('#root is missing from index.html');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
